(function () {
    'use strict';

    angular.module('app.ui')
        .directive('uiDataTable', dataTable);

    /* @ngInject */
    function dataTable(DataFactory, Blob, FileSaver, Papa) {

        return {
            restrict: 'E',
            templateUrl: 'views/ui/data-table.html',
            scope: {
                tableDataKey: '@',
                tableData: '=',
                title: '@'
            },
            link: link
        };

        function link(scope) {
            scope.$watch('tableDataKey', function (newVal) {
                if (newVal === undefined) {
                    return;
                }
                DataFactory.getTableData(scope.tableDataKey).then(function (data) {
                    scope.tableData = data;
                });
            });

            scope.$watch('tableData', function (newVal) {
                if (newVal === '' || newVal === undefined) {
                    return;
                }
                scope.tableData = newVal;
            });

            scope.downloadData = function () {

                var data = {
                    fields: scope.tableData.columns,
                    data: []
                };

                angular.forEach(scope.tableData.rows, function (row) {
                    data.data.push(row.values);
                });

                var blob = new Blob([Papa.unparse(data)], {type: 'text/csv'});
                FileSaver.saveAs(blob, scope.title + '.csv');
            };
        }
    }
})();